import { Chip, ChipProps } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

interface AccessCustomChipProps {
  label: ChipProps["label"];
  color?: ChipProps["color"];
  icon?: ChipProps["icon"];
  onDelete?: () => void;
}

const AccessCustomChip = (props: AccessCustomChipProps) => {
  const { label, color, icon, onDelete } = props;
  return (
    <Chip
      label={label}
      variant="outlined"
      size="small"
      color={color}
      onDelete={onDelete}
      deleteIcon={onDelete ? <CloseOutlinedIcon /> : undefined}
      icon={icon}
      sx={{
        "& .MuiChip-deleteIcon": {
          color: `${color}.main`,
        },
        backgroundColor: `${color}.alpha`,
      }}
    />
  );
};

export default AccessCustomChip;
